
import { Link } from 'react-router-dom';
import PageHero from '../../../components/base/PageHero';

export default function SETAHeroSection() {
  return (
    <PageHero
      breadcrumb="SETA Compliance"
      label="Skills Development Act"
      title={<>SETA Compliance<br />Made Simple</>}
      description="Expert guidance on WSP/ATR reporting, SETA grant recovery, and Skills Development Act obligations — so you stay compliant and maximise your training levy."
      bgImage="/seta-compliance-hero.png"
    >
      <Link to="/contact"><button className="btn btn-white">Book a Compliance Review <i className="ri-arrow-right-line ml-2" /></button></Link>
      <a href="#guide"><button className="btn btn-ghost">Free Compliance Guide</button></a>
    </PageHero>
  );
}
